import { render } from "./forgot_password.html?vue&type=template&id=e17e43c0&external"
import script from "./forgot_password.js?vue&type=script&lang=js&external"
export * from "./forgot_password.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__